export default (association) => {
  switch (association.toLowerCase()) {
    case 'deal':
    case 'deals':
      return 'fas fa-briefcase'
    case 'person':
    case 'people':
      return 'fas fa-user'
    case 'company':
    case 'companies':
      return 'far fa-building'
    case 'customer':
      return 'fas fa-users'
    case 'task':
    case 'todo':
    case 'todos':
      return 'far fa-check-square'
    case 'event':
      return 'far fa-calendar-alt'
    case 'import':
    case 'file':
    case 'files':
      return 'fas fa-file-alt'
    case 'recipient':
    case 'recipients':
      return 'fas fa-envelope'
  }
}
